import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Div, Paginator } from "components/Base";
import { actions, getters } from "../../model";
import Session from "./Session";
import Sidebar from "./Sidebar";
import { SuperClearInput, SearchIcon } from "components/Base";
import { debounce, noop } from "lodash";

const decorate = connect(
  (state, props) => ({
    sessionsToConvert: getters.sessionsToConvert(state, props),
    loading: getters.loading(state, props),
    sessionsToConvertCounter: getters.sessionsToConvertCounter(state, props),
    pagination: getters.pagination(state, props),
    linkSessionsToSubsessionsTab: getters.linkSessionsToSubsessionsTab(state),
    filter: getters.filter(state, props)
  }),
  {
    selectItem: actions.selectItem,
    searchSessions: actions.searchSessions,
    setFilter: actions.setFilter,
    handleChangeResultPerPage: actions.handleChangeResultPerPage,
    handleChangePages: actions.handleChangePages,
    setPagination: actions.setPagination
  }
);

const View = ({
  sessionsToConvert = [],
  searchSessions = noop,
  setFilter = noop,
  filter = "",
  pagination = {},
  sessionsToConvertCounter = 0,
  handleChangePages = noop,
  handleChangeResultPerPage = noop,
  setPagination = noop
}) => {
  const handleFilter = filter => {
    setFilter(filter);
    setPagination({ ...pagination, page: 1 });
    searchSessions({ filter });
  };

  return (
    <>
      <Div
        height={460}
        style={{ display: "flex", overflowY: "auto", flexDirection: "row" }}
        mb={3}
        width={1}
      >
        <Div mt={3} display="column.flex-start.flex-start" width={1}>
          <Div mt={3} display="row.flex-start.flex-start" width={1}>
            <Div
              mb={3}
              style={{
                width: "85%"
              }}
            >
              <SuperClearInput
                continuous
                value={filter}
                placeholder="Search for existing sessions"
                onChange={debounce(e => handleFilter(e), 300)}
                LeftIcon={SearchIcon}
                leftIconColor="gray6"
                flex={1}
                style={{
                  height: 65,
                  width: "100%"
                }}
              />
              {sessionsToConvert.length ? (
                <>
                  {R.map(
                    session => (
                      <Session session={session} />
                    ),
                    sessionsToConvert
                  )}
                </>
              ) : (
                <Div
                  display="column.center.center"
                  style={{
                    backgroundColor: "#EEE"
                  }}
                  color="gray5"
                  bra={1}
                  fw={3}
                  fs={3}
                  p={3}
                >
                  No Sessions Found: {filter}
                </Div>
              )}
            </Div>
            <Sidebar />
          </Div>
          <Div
            mt={3}
            style={{
              width: "65%"
            }}
          >
            {sessionsToConvert.length && (
              <Paginator
                showingResultsProps={{ label: "records" }}
                goTo={e => handleChangePages({ page: e })}
                resultsPerPage={R.propOr(10, "pageSize", pagination)}
                paginatorLength={10}
                totalNumResults={sessionsToConvertCounter}
                currentPage={pagination?.page}
                selectOptions={[10, 25, 50, 100]}
                onSelectResultsPerPage={e =>
                  handleChangeResultPerPage({ pageSize: e })
                }
                showPerPageSelector={true}
                showResultsDisplay={false}
              />
            )}
          </Div>
        </Div>
        <Div h={30}></Div>
      </Div>
    </>
  );
};

export default decorate(View);
